<template>

<div >

<div>

  <v-app id="inspire">
    <v-content>
      <v-container  fluid>

        <v-row >
          <v-col cols="12" sm="8" md="12">
            <v-card class="elevation-12">
              <v-toolbar color="blue" dark flat>
                <v-toolbar-title></v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>

               <v-form ref="form" v-model="valid"  lazy-validation>
                   <v-col cols="4">
                  <v-select
                  v-model="documento"
                  item-value="pkDoc"
                  item-text="descricao"
                 :items="documentos"
                 label="Tipo do Documento"
                return-object
        ></v-select>
     <v-card-actions>

                <v-btn @click="criarDocumento()" color="primary">Criar</v-btn>
                <v-btn @click="imprimir()" color="primary">Imprimir</v-btn>

              </v-card-actions>
        </v-col>

        <template>
<div>
   <iframe  style="width:100%;height:500px" :src="this.url"  title="W3Schools Free Online Web Tutorials"></iframe>
</div>
    </template>

                </v-form>

              </v-card-text>

            </v-card>
          </v-col>

        </v-row>

      </v-container>
    </v-content>

  </v-app>

    </div>
  </div>
</template>

<script>

import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /(([-{0-9}]))$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    valid: false,
    url: '',
    html: '',
    documento: {
      'pkDoc': 0,
      'descricao': ''
    },
    documentos: [
      {
        'pkDoc': 1,
        'descricao': 'Factura'
      },
      {
        'pkDoc': 2,
        'descricao': 'Factura Proforma'
      },
      {
        'pkDoc': 3,
        'descricao': 'Factura Consignação'
      },
      {
        'pkDoc': 4,
        'descricao': 'Factura Recibo'
      },
      {
        'pkDoc': 5,
        'descricao': 'Talão de venda'
      },
      {
        'pkDoc': 6,
        'descricao': 'venda a Dinheiro'
      }

    ],
    factura:
{
  'nome_empresa': 'Vadão Comercial',
  'cliente': 'Alexandrina Francisco de Almeida',
  'localidade': 'Kinanga, rua 2',
  'provincia': 'Luanda',
  'NIF': '2401268340',
  'factura_recibo': 'FR 2/20571',
  'items': [
    {
      'qtd': '1',
      'produto': 'H2O Pura Grande 1 5l',
      'unit': '250,00',
      'subT': '250,00',
      'tx': '0',
      'ref': 'WDBWLG0040HB'
    }
  ],
  'total': '250,00 kz',
  'modo_pagamento': [{
    'metodo': 'Numerário',
    'moeda': 'AOA',
    'total': '250,00'
  }
  ],
  'resumo_imposto': [
    {
      'tx': 'IVA-Regime de não sujeição',
      'total_imposto': '',
      'incidencia': ''
    },
    {
      'tx': '0,00',
      'total_imposto': '0,00',
      'incidencia': '250,00'
    }
  ],
  'number_item': 1,
  'tiDQ': 'tiDQ-Processado por programa validado',
  'utilizador': 'Pedro'
},
    mes_ano: '',
    data_actual: '',
    dataHora: ''
  }),
  created () {
    this.data_hora()
  },

  methods: {
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    data_hora () {
      let data = new Date()
      this.mes_ano = (data.getFullYear()) + (data.getMonth() + 1)
      this.data_actual = data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear())
      this.dataHora = data.getDate() + '-' + (data.getMonth() + 1) + '-' + (data.getFullYear()) + 'T' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
      console.log('Data: ' + this.dataHora)
    },
    imprimir () {
      this.url = 'http://localhost:4001/print_html_pdf/' + ls.get('nomeUsuario') + ''
    },
    async addHtml () {
      let html_ = { 'html': this.html, 'usuario': ls.get('nomeUsuario'), 'pkDoc': this.documento.pkDoc }

      try {
        this.pdf = await axios
          .post('/html_pdf', html_)
          .then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async criarDocumento () {
      if (this.$refs.form.validate()) {
        this.url = ''
        if (this.documento.pkDoc === 4) {
          this.maxLength(this.factura)
        } else {
          this.outrasFacturas()
        }
      }
    },
    // Enviando a maior quantidade de linhas das tabelas (Items, Modo de Pagamento, Resumo de Imposto)
    maxLength (factura) {
      if (factura.items.length >= factura.modo_pagamento.length && factura.items.length >= factura.resumo_imposto.length) { return this.comporHtml(factura.items.length) } else
      if (factura.modo_pagamento.length >= factura.items.length && factura.modo_pagamento.length >= factura.resumo_imposto.length) { return this.comporHtml(factura.modo_pagamento.length) } else
      if (factura.resumo_imposto.length >= factura.items.length && factura.resumo_imposto.length >= factura.modo_pagamento.length) { return this.comporHtml(factura.resumo_imposto.length) }
    },
    // Dado a maior quantidade de linhas das tabelas compõe o HTML
    comporHtml (maxLength) {
      let index = 0
      let items = ''
      let modoPagamento = ''
      let resumoImposto = ''
      for (index = 0; index < maxLength; index++) {
        /** As extruturas de decisão dentro ciclo servem para
        Garantir que o número de interação seja preciso  */
        if (index < this.factura.items.length) {
          items += ` <tr>
                              
                              <td style="font-size: 10px;" class="linha">` + this.factura.items[index].qtd + `</td>
                              <td style="font-size: 10px;" class="linha">` + this.factura.items[index].produto + `</td>
                               <td style="font-size: 10px;" class="linha"></td>
                              <td style="font-size: 10px;" class="linha">` + this.factura.items[index].unit + `</td>
                              <td style="font-size: 10px;" class="linha">` + this.factura.items[index].subT + ` </td>
                              <td style="font-size: 10px;" class="linha">` + this.factura.items[index].tx + `</td>
                                                        
                        </tr>`
        }
        if (index < this.factura.modo_pagamento.length) {
          modoPagamento += `<tr>
                              
                              <td style="font-size: 10px;" class="linha">` + this.factura.modo_pagamento[index].metodo + `</td>
                              <td style="font-size: 10px;" class="linha">` + this.factura.modo_pagamento[index].moeda + `</td>
                               <td style="font-size: 10px;" class="linha"></td>
                              <td style="font-size: 10px;" class="linha">` + this.factura.modo_pagamento[index].total + `</td>
                              <td style="font-size: 10px;" class="linha"></td>                                                       
                        </tr>
                        `
        }
        if (index < this.factura.resumo_imposto.length) {
          resumoImposto += `<tr>
                              
                              <td style="font-size: 10px;" class="linha">` + this.factura.resumo_imposto[index].tx + `</td>
                              <td style="font-size: 10px;" class="linha">` + this.factura.resumo_imposto[index].total_imposto + `</td>
                               <td style="font-size: 10px;" class="linha"></td>
                              <td style="font-size: 10px;" class="linha">` + this.factura.resumo_imposto[index].incidencia + `</td>
                              <td style="font-size: 10px;" class="linha"></td>                                                       
                        </tr>`
        }
      }
      if (index === maxLength) {
        this.html = ` 
    <style>
.footer {
    position:absolute;
    bottom:0;
    width:100%;
}
#content {
    display: table;
}

#pageFooter {
    display: table-footer-group;
     position:absolute;
    bottom:0;
    width:100%;
}

#pageFooter:after {
    counter-increment: page;
    content: counter(page);
}
.linha {
    border-bottom: 1px solid black !important;
}
  

</style>
    
    <div style="text-align:center;margin:10px;margin-top:0px" class="invoice-box">
        <h3 style="margin-top:15px;font-size: 14px;">` + this.factura.nome_empresa + `</h3>
        <p style="font-size: 10px;">` + this.factura.cliente + `</p>
        <p style="font-size: 10px;">` + this.factura.localidade + `</p>
        <p style="font-size: 10px;">` + this.factura.provincia + `</p>
        <p style="font-size: 10px;">NIF: ` + this.factura.NIF + `</p>
        <p style="font-size: 10px;">Factura Recibo Nº: ` + this.factura.factura_recibo + `</p>
        <p style="font-size: 10px;">ORIGINAL</p>
        <p style="font-size: 10px;text-align:center">Nome: Consumidor Final</p>
        <p style="font-size: 10px;text-align:center">Contribuente: Consumidor Final</p>

<div> 
    <span style="text-align:LEFT; font-size: 10px;"> DATA: </span> 
    <span style="text-align:right; font-size: 10px;"> HORA: </span>
</div>

<table style="border:0px solid black;margin-left:auto;margin-right:auto;width:100%"> 
  <tr  >
                    <td style="font-size: 10px;"  class="linha">
                  Qnt
                    </td>
                    <td style="font-size: 10px;" colspan="2" class="linha">
                      Produto
                    </td>
                      <td style="font-size: 10px;" class="linha">
                  Unit
                    </td>
                      <td style="font-size: 10px;" class="linha">
                  SubT
                    </td>
                      <td style="font-size: 10px;" class="linha">
                  Tx
                    </td>
                </tr>
                 
                ` + items + `
                       
</table>

<h2 style="text-align:center;font-size: 10px;">TOTAL: ` + this.factura.total + `</h2>

<p style="font-size: 10px;text-align:center;">Modos de Pagamento</p>

<table style="border:0px solid black;margin-left:auto;margin-right:auto;width:100%"> 
  <tr  >
                    <td style="font-size: 10px;"  class="linha">
                  Metodo
                    </td>
                    <td  style="font-size: 10px;" colspan="2" class="linha">
                     Moeda
                    </td>
                      <td  style="font-size: 10px;" colspan="2" class="linha">
                  Total
                    </td>
                </tr>
                 
                   ` + modoPagamento + `
</table>

<p style="font-size: 12px;text-align:center;">Resumo de Impostos</p>

<table style="border:0px solid black;margin-left:auto;margin-right:auto;width:100%"> 
  <tr  >
                    <td style="font-size: 10px;"  class="linha">
                  Tx
                    </td>
                    <td style="font-size: 10px;" colspan="2" class="linha">
                     Total Imposto
                    </td>
                      <td style="font-size: 10px;" colspan="2" class="linha">
                 Incidencia
                    </td>
                </tr>
                 ` + resumoImposto + `
</table>
<p style="font-size: 10px;text-align:center;">Nº. de items: ` + this.factura.number_item + `</p>
<p style="font-size: 10px;text-align:center;">` + this.factura.tiDQ + `</p>
<p style="font-size: 10px;text-align:center;">N.73/AGT/2019/XD Software</p>
<p style="font-size: 10px;text-align:center;">Utilizador: ` + this.factura.utilizador + `</p>

</div>
 <div class="footer" style="font-size: 12px;text-align:center">
*Obrigado e volte sempre*
</div>
              `
        setTimeout(() => {
          this.addHtml()
        }, 0)
      }
    },
    outrasFacturas () {
      let items = ''
      let index = 0
      for (index = 0; index < this.factura.items.length; index++) {
        items += ` <tr class="linhas">
    <td class="linhas"> ` + this.factura.items[index].ref + `</td>
    <td class="linhas" >` + this.factura.items[index].produto + `</td>
    <td class="linhas"> ` + this.factura.items[index].unit + `</td>
    <td style="text-align:center" class="linhas">` + this.factura.items[index].qtd + `</td>
    <td style="text-align:center" class="linhas">0,00</td>
    <td class="linhas"> 0,00Z</td>
    <td class="linhas"> ` + this.factura.items[index].unit + `</td>
  </tr> `
      }
      if (index === this.factura.items.length) {
        this.html = `<style>
        #rcorners2 {
  border-radius: 25px;
  border: 2px solid #000000;
  padding: 20px; 
  width: 250px;
  height: 70px;  
}
.footer {
    position:absolute;
    bottom:0;
    width:100%;
}
#content {
    display: table;
}

#pageFooter {
    display: table-footer-group;
     position:absolute;
    bottom:0;
    width:100%;
}
.column {
  float: left;
  width: 33.33%;
  padding: 5px;
}

#pageFooter:after {
    counter-increment: page;
    content: counter(page);
}
.linhas {
  border: 1px solid black;
  border-collapse: collapse;
}

</style>
    <html>
        <head>
<title></title>

        </head>
    <body>  
           <div class="invoice-box">
        
<table style="border:0px solid black;margin-left:0px;margin-right:auto;">
    <tr>
        <td>
            <div class="column">
   <span style="padding-top:1px!important">  <img src="http://restrito.esaudeluanda.com:7000/config/IMS/icon/logo.png" alt="Snow" style="width:100%; max-width:150px;" /></span>
  </div>
        </td>
         <td> 
        <br>Bairro da Praia doBispo nº 7 Ingombota
         <br>Luanda-Angola
         <br>NIF:5417492760
         <br>Telefones:948 105 702 /948 106 782
         <br>contacto.softline@gmail.com
            <br>cobranca.softline@gmail.com
        </td>
         
        <td>
            <div style="text-align:right;padding-left:150px">
        <span > <strong >` + this.documento.descricao + ` Nº :` + this.mes_ano + `</strong>
                   <br>Data de Emissão: ` + this.data_actual + `
                   <br>Data de Validade: ` + this.data_actual + `</span></div>
        </td>
    </tr>
    
       </table>
                 
    <div  style="margin-top:15px;">
  <p id="rcorners2">
       Nº de Cliente: 1
                   <br> Contribuente: ---
                  <br>  Cond. Pagamento:
                  <br>  Modo Exp. : Carro</p>              
                </div>
                   
<table style="width:100%" class="linhas">
  <tr class="linhas">
    <th bgcolor="#DCDCDC" class="linhas">Ref</th>
    <th bgcolor="#DCDCDC" class="linhas">Produto</th> 
    <th bgcolor="#DCDCDC" class="linhas" >Preço</th>
    <th bgcolor="#DCDCDC" class="linhas">Qtd</th>
    <th bgcolor="#DCDCDC" class="linhas">Dsc.</th>
    <th bgcolor="#DCDCDC" class="linhas">IVA</th>
    <th bgcolor="#DCDCDC" class="linhas">Total</th>
  </tr> 
  ` + items + `
  </table>
        
 <div style="margin-top:15px; text-align:right;">
  <span> <strong>Total:</strong>  106 186,92 AKZ  </span>              
                </div>

<div style="padding-top:90px; text-align:center;">
  <span>PREÇOS COM IVA INCLUIDO À TAXA DE 14%  </span>              
                </div>
<div class="footer">
  <p align="center"><b>Forma de pagamento</b> </p>
   <table style="border:0px solid black;margin-left:auto;margin-right:auto;">
      <tr>
      <td ><b>Transferência Bancária: </b> BAI IBAN/NIB - AO06 0040 0000 823020751012 1  
           </h2></td>
                  </tr> 
      </tr>
</table>
  
           
</div>
    </body>
    </html>
        
        `
        setTimeout(() => {
          this.addHtml()
        }, 0)
      }
    }
  }

}

</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
